import React from 'react';
import PropTypes from 'prop-types';

export default class Radio extends React.Component {
  static propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    tabIndex: PropTypes.number,
    onKeyUp: PropTypes.func,
  };

  static defaultProps = {
    className: '',
    readOnly: false,
  };

  /**
   * Binds all private methods
   * @param  {Object} props Component props
   */
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.node = React.createRef();
  }

  handleKeyUp = (event) => {
    const { onKeyUp } = this.props;

    event.preventDefault();

    if ([' ', 'Spacebar'].includes(event.key)) {
      this.radioInputNode.click();
      return;
    }

    if (onKeyUp) {
      onKeyUp(event);
    }
  };

  handleClick() {
    this.radioInputNode.click();
  }

  focus = () => {
    this.node.current.focus();
  };

  render() {
    const id = this.props.id || this.props.name;

    const label = (
      <label htmlFor={id} className="radioinput__label">
        {this.props.label}
      </label>
    );

    return (
      <div
        ref={this.node}
        tabIndex="0"
        role="radio"
        aria-checked={this.props.checked}
        className={`radioinput ${this.props.className}`}
        onClick={this.handleClick}
        onKeyUp={this.handleKeyUp}
      >
        <input
          ref={(node) => (this.radioInputNode = node)}
          className="radioinput__field"
          type="radio"
          id={id}
          name={this.props.name}
          checked={this.props.checked}
          onChange={this.props.onChange}
          tabIndex={this.props.tabIndex}
          value={this.props.value}
        />
        <div className="radioinput__check" />
        {label}
      </div>
    );
  }
}
